export type ArticleItem = {
  title: string;
  author?: string;
  date: string;
  img: string;
};

export type CategorySection = {
  label: string;
  href: string;
  items: ArticleItem[];
};

export const lifestyleSection: CategorySection = {
  label: "LIFESTYLE",
  href: "/ejinsight/lifestyle",
  items: [
    {
      title: "HK Ballet's Glam Rock",
      author: "Kevin Ng",
      date: "April 14, 2026 10:59",
      img: "/images/ejinsight/lifestyle-1.png",
    },
    {
      title: "Peony Pavilion from Suzhou",
      author: "Kevin Ng",
      date: "April 07, 2026 10:58",
      img: "/images/ejinsight/lifestyle-2.png",
    },
    {
      title: "Modern dance delights in HK Arts Festival",
      author: "Kevin Ng",
      date: "March 17, 2026 16:14",
      img: "/images/ejinsight/lifestyle-3.png",
    },
    {
      title: "Roberto Bolle starred in HK Arts Festival",
      author: "Kevin Ng",
      date: "March 09, 2026 18:21",
      img: "/images/ejinsight/lifestyle-4.png",
    },
  ],
};

export const businessSection: CategorySection = {
  label: "BUSINESS",
  href: "/ejinsight/business",
  items: [
    {
      title: "Fiscal Dominance and Negative Rates Risk",
      date: "April 23, 2026 13:23",
      img: "/images/ejinsight/business-1.png",
    },
    {
      title: "AI:It's Time to Execute Not Experiment–But is Your Data Ready",
      date: "March 19, 2026 10:11",
      img: "/images/ejinsight/business-2.png",
    },
    {
      title: "EU takes on e-commerce giant Shein",
      date: "February 24, 2026 17:32",
      img: "/images/ejinsight/business-3.png",
    },
    {
      title: "China profits from both sides in Ukraine war",
      author: "Mark O'Neill",
      date: "February 13, 2026 18:05",
      img: "/images/ejinsight/business-4.png",
    },
  ],
};

export const worldSection: CategorySection = {
  label: "WORLD",
  href: "/ejinsight/world",
  items: [
    {
      title: "The Most Influential Foreigner in Qing China",
      author: "Mark O'Neill",
      date: "April 26, 2026 21:15",
      img: "/images/ejinsight/world-1.png",
    },
    {
      title: "U.S. wants the Castro family to leave Cuba",
      date: "April 24, 2026 17:24",
      img: "/images/ejinsight/world-2.png",
    },
    {
      title: "Putin wants to live for ever",
      author: "Mark O'Neill",
      date: "April 19, 2026 23:09",
      img: "/images/ejinsight/world-3.png",
    },
    {
      title: "Is Russia losing the war?",
      author: "Mark O'Neill",
      date: "April 15, 2026 14:17",
      img: "/images/ejinsight/world-4.png",
    },
  ],
};

export const featuresSection: CategorySection = {
  label: "FEATURES",
  href: "/ejinsight/features",
  items: [
    {
      title: "Protect yourself from dual attacks of pneumococcal disease & flu",
      date: "July 04, 2025 08:00",
      img: "/images/ejinsight/features-1.png",
    },
  ],
};

export type HongKongCard = {
  title: string;
  author: string;
  img: string;
};

export const hongKongCards: HongKongCard[] = [
  {
    title: "Government rewrites history of Hong Kong",
    author: "Mark O'Neill",
    img: "/images/ejinsight/hk-1.png",
  },
  {
    title: "Hong Kong Turns Green for a Day",
    author: "Mark O'Neill",
    img: "/images/ejinsight/hk-2.png",
  },
  {
    title: "First two HK martyrs in Ukraine war were “so brave, so selfless”",
    author: "Mark O'Neill",
    img: "/images/ejinsight/hk-3.png",
  },
  {
    title: "How the Irish Made Hong Kong",
    author: "Mark O'Neill",
    img: "/images/ejinsight/hk-4.png",
  },
  {
    title: "HK people in UK fear new immigration rules",
    author: "Mark O'Neill",
    img: "/images/ejinsight/hk-5.png",
  },
];

export const columnistImages: { name: string; img: string }[] = [
  { name: "Michael Chugani", img: "/images/ejinsight/columnist-michael-chugani.png" },
  { name: "Stephen Vines", img: "/images/ejinsight/columnist-stephen-vines.png" },
  { name: "Frank Ching", img: "/images/ejinsight/columnist-frank-ching.png" },
  { name: "Mark O'Neill", img: "/images/ejinsight/columnist-mark-oneill.png" },
  // Neville, not "Neille" — the reference author page (id 8912) has it as
  // Neville Sarony. The avatar file keeps its old name.
  { name: "Neville Sarony", img: "/images/ejinsight/columnist-neille-sarony.png" },
  { name: "Brian Y. S. Wong", img: "/images/ejinsight/columnist-brian-wong.png" },
];

export type NavLink = { label: string; href: string; isHome?: boolean };

// Most EJ Insight category routes don't have dedicated v2 list pages yet.
// These are CATEGORIES, so they point at the category route. They used to be
// routed through `/ejinsight/tag/<slug>` "so links resolve" — but none of those
// five slugs exists in `tagsBySlug`, so every one 404'd anyway.
export const navLinks: NavLink[] = [
  { label: "Home", href: "/ejinsight", isHome: true },
  { label: "Hong Kong", href: "/ejinsight/hong-kong" },
  { label: "Business", href: "/ejinsight/business" },
  { label: "World", href: "/ejinsight/world" },
  { label: "Lifestyle", href: "/ejinsight/lifestyle" },
  { label: "Features", href: "/ejinsight/features" },
  { label: "Startups", href: "/ejinsight/startups" },
];

export const footerLinks: { label: string; href: string }[] = [
  { label: "About us", href: "/ejinsight/about" },
  { label: "Contact us", href: "/ejinsight/contact" },
  { label: "Advertise", href: "/ejinsight/contact" },
  { label: "HKEJ", href: "/" },
  { label: "Terms of Service", href: "/legal/membership" },
  { label: "Privacy Policy", href: "/legal/privacy" },
  { label: "Disclaimer", href: "/legal/disclaimer" },
];

// Columnist directory metadata (role + their latest column). Keyed by name to
// match the `columnistImages` roster; consumed by the home columnists section
// and rail.
export const columnistBios: Record<
  string,
  { role: string; latest: string; date: string }
> = {
  "Michael Chugani": {
    role: "Politics & Society",
    latest: "Why Hong Kong's middle class is voting with its feet",
    date: "April 22, 2026",
  },
  "Stephen Vines": {
    role: "Hong Kong Affairs",
    latest: "The new normal in Hong Kong's media landscape",
    date: "April 18, 2026",
  },
  "Frank Ching": {
    role: "Greater China",
    latest: "Does Hong Kong have the right not to enact article 23 laws?",
    date: "March 27, 2026",
  },
  "Mark O'Neill": {
    role: "World Affairs",
    latest: "China profits from both sides in the Ukraine war",
    date: "February 13, 2026",
  },
  "Neville Sarony": {
    role: "Law & Justice",
    latest: "Rule of law and the price of dissent",
    date: "April 09, 2026",
  },
  "Brian Y. S. Wong": {
    role: "Public Policy",
    latest: "Re-imagining Hong Kong's role in the Greater Bay Area",
    date: "April 02, 2026",
  },
};
